import { BILLING_ACCOUNT_STATUS } from '../constants/status.ts';

import type { Billing20201105BillingAccountStatus } from '@clients/cloud-billing';

export default class AccountStatus {
  #status: Billing20201105BillingAccountStatus | null;

  /**
   * @param status - The billing account status (optional)
   */
  constructor(status: Billing20201105BillingAccountStatus | null) {
    this.#status = status;
  }

  /** Returns true if the account is active */
  get isActive() {
    return this.#status === BILLING_ACCOUNT_STATUS.ACTIVE;
  }

  /** Returns true if the account is delinquent */
  get isDelinquent() {
    return this.#status === BILLING_ACCOUNT_STATUS.DELINQUENT;
  }

  /** Returns true if the account is a trial */
  get isTrial() {
    return this.#status === BILLING_ACCOUNT_STATUS.TRIAL;
  }

  /** Returns true if the account is incomplete */
  get isIncomplete() {
    return this.#status === BILLING_ACCOUNT_STATUS.INCOMPLETE;
  }

  valueOf() {
    return this.#status;
  }
}
